import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { HttpService } from 'src/app/shared/http.service';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  ordering: any = [];
  menu: any = [];
  permissions: any;
  toggle: any = true;
  menuItems: MenuItem[] = [];
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(private httpService: HttpService, private ngxPermissionsService: NgxPermissionsService,
    private router: Router,) { }

    ngOnInit(): void {
      // Menu Items
      const menus = this.httpService.menus();
      const filteredMenus = menus.filter((x: any) => x.AccessTypeId != null);
      this.permissions = filteredMenus.map((x: any) => x.Id);
      
      let count = 0;
      this.ordering = [];
      this.menu = [];
      MENU.forEach(item => {
        if (item.link == '') {
          item.permissions.forEach((permission: any, index: number) => {
            this.ordering[count] = permission;
            this.menu.push(item.subItems[index]);
            count++;
          });
        } else {
          this.ordering[count] = item.permissions[0];
          this.menu.push(item);
          count++;
        }
      });
    
      this.menuItems = MENU;
      
      const storeMenu = localStorage.getItem("storeMenu");
      if (storeMenu) {
        const localItem = JSON.parse(storeMenu);
        setTimeout(() => {
          localItem.forEach((obj: any) => {
            $('#' + obj).addClass('active');
            const isMenu = $('#' + obj).next();
            if (isMenu) {
              isMenu[0].classList.add('show');
              const isCurrentMenuId = $('#' + obj).closest('a.nav-link');
              isCurrentMenuId[0].setAttribute("aria-expanded", "true");
              if (isCurrentMenuId) {
                this.activateParentDropdown(isCurrentMenuId[0]);
              }
            }
          });
        }, 100);
      }
    } 

  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    this.initActiveMenu();
  }

  removeActivation(items: any) {
    items.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        (item.nextElementSibling) ? item.nextElementSibling.classList.remove("show") : null;
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  }

  toggleSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    let dropDowns = Array.from(document.querySelectorAll('.sub-menu'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });

    let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
    subDropDowns.forEach((submenu: any) => {
      submenu.setAttribute('aria-expanded', "false");
    });

    if (event.target && event.target.nextElementSibling) {
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      event.target.nextElementSibling.classList.toggle("show");
    }
  };

  toggleExtraSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    let dropDowns = Array.from(document.querySelectorAll('.extra-sub-menu'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });

    let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
    subDropDowns.forEach((submenu: any) => {
      submenu.setAttribute('aria-expanded', "false");
    });

    if (event.target && event.target.nextElementSibling) {
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      event.target.nextElementSibling.classList.toggle("show");
    }
  };

  // Click wise Parent active class add
  toggleParentItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const iconItems = Array.from(ul.getElementsByTagName("a"));
      let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
      activeIconItems.forEach((item: any) => {
        item.setAttribute('aria-expanded', "false")
        item.classList.remove("active");
      });
    }
    isCurrentMenuId.setAttribute("aria-expanded", "true");
    if (isCurrentMenuId) {
      this.activateParentDropdown(isCurrentMenuId);
    }
  }

  toggleItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    if (isMenu.classList.contains("show")) {
      isMenu.classList.remove("show");
      if (!isMenu.querySelector('a.active')) {
        isCurrentMenuId.classList.remove("active");
      }
      isCurrentMenuId.setAttribute("aria-expanded", "false");
      var storedArray = JSON.parse(localStorage.getItem('storeMenu')!) || [];

      // Step 2: Find the index of the id you want to remove
      var idToRemove = isCurrentMenuId.id; // Replace with the id you want to remove
      var index = storedArray.findIndex(function (id: any) {
        return id === idToRemove;
      });

      // Step 3: Remove the id from the array if it exists
      if (index !== -1) {
        storedArray.splice(index, 1);
      }

      // Step 4: Update the modified array in local storage
      localStorage.setItem('storeMenu', JSON.stringify(storedArray));
    } else {
      var storeMenu = JSON.parse(localStorage.getItem('storeMenu')!) || [];

      // Step 2: Push the new isCurrentMenuId.id into the array
      storeMenu.push(isCurrentMenuId.id);

      // Step 3: Save the updated storeMenu array back to local storage
      localStorage.setItem('storeMenu', JSON.stringify(storeMenu));
      let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
      dropDowns.forEach((node: any) => {
        //node.classList.remove('show');
      });

      (isMenu) ? isMenu.classList.add('show') : null;
      const ul = document.getElementById("navbar-nav");
      if (ul) {
        const iconItems = Array.from(ul.getElementsByTagName("a"));
        let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
        activeIconItems.forEach((item: any) => {
          // item.setAttribute('aria-expanded', "false")
          // item.classList.remove("active");
        });
      }
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      if (isCurrentMenuId) {
        this.activateParentDropdown(isCurrentMenuId);
      }
    }
  }

  activateParentDropdown(item: any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  updateActive(event: any, index: any = 0) {
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      //this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);
    // setTimeout(function () {
    //   $('.nav-subItems-' + index).addClass('active');
    // }, 0);
  }

  initActiveMenu() {
    let that = this;
    let pathName = window.location.pathname;
    let activemenu: any;
    for (var i = 0; i < that.ordering.length; i++) {
      let activePermission = that.permissions.find((x: any) => x == that.ordering[i]);
      if (activePermission != undefined) {
        activemenu = that.menu.find((m: { permissions: any[]; }) => m.permissions[0] == activePermission);
        if (activemenu) {
          break;
        }
      }
    }
    if (pathName == "/" && activemenu) {
      pathName = activemenu.link;
    }
    setTimeout(() => {
      const ul = document.getElementById("navbar-nav");
      if (ul) {
        const items = Array.from(ul.querySelectorAll("a.nav-link"));
        let activeItems = items.filter((x: any) => x.classList.contains("active"));
        this.removeActivation(activeItems);

        let matchingMenuItem = items.find((x: any) => {
          var path = pathName.split("/");
          var path1 = path && path[1] ? path[1] : "";
          var fullPathName = "/" + path1;
          return x.pathname === fullPathName;
        });

        if (matchingMenuItem) {
          this.activateParentDropdown(matchingMenuItem);
        }
      }
    }, 0);

  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    var sidebarsize = document.documentElement.getAttribute("data-sidebar-size");
    if (sidebarsize == 'sm-hover-active') {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover')
    } else {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover-active')
    }
  }

  /**
   * SidebarHide modal
   * @param content modal content
   */
  SidebarHide() {
    document.body.classList.remove('vertical-sidebar-enable');
  }

}
